import { Injectable } from '@angular/core';
import { Step } from '../components/stepper/step';

@Injectable()
export class StepsService {
	private currentStep: number;

	get getCurrentStep() {
		return this.currentStep;
	}

	setStep(steps: Step[], currentStep: number) {
		this.currentStep = currentStep;
		return steps.map((step, index) => {
			if (index <= currentStep) {
				step.isActive = true;
			} else {
				step.isActive = false;
			}
		});
	}

	moveNextStep(steps: Step[]): void {
		this.currentStep++;
		this.setStep(steps, this.currentStep);
	}

	moveBackStep(steps: Step[]): void {
		this.currentStep--;
		this.setStep(steps, this.currentStep);
	}

	getTransactionSteps(component: string): Step[] {
		switch (component) {
			case 'EmailPassRestore':
				return [
					{ title: 'Εισαγωγή κωδικού', step: 0, isActive: false },
					{ title: 'Νέο password', step: 1, isActive: false },
					{ title: 'Επιβεβαίωση', step: 2, isActive: false },
					{ title: 'Ολοκλήρωση', step: 3, isActive: false },
				];
			case 'RestoreWithAuthentication':
				return [
					{ title: 'Εισαγωγή στοιχείων', step: 0, isActive: false },
					//{ title: 'Κωδικός επιβεβαίωσης', step: 1, isActive: false },
					{ title: 'Νέο password', step: 1, isActive: false },
					{ title: 'Επιβεβαίωση', step: 2, isActive: false },
					{ title: 'Ολοκλήρωση', step: 3, isActive: false },
				];
			case 'RestoreWithPasswordAuthentication':
				return [
					{ title: 'Εισαγωγή στοιχείων', step: 0, isActive: false },
					{ title: 'Κωδικός επιβεβαίωσης', step: 1, isActive: false },
					{ title: 'Νέο password', step: 2, isActive: false },
					{ title: 'Επιβεβαίωση', step: 3, isActive: false },
					{ title: 'Ολοκλήρωση', step: 4, isActive: false },
				];
			case 'RestorePasswordWithCard':
				return [
					{ title: 'Στοιχεία κάρτας', step: 0, isActive: false },
					{ title: 'Νέο password', step: 1, isActive: false },
					{ title: 'Επιβεβαίωση', step: 1, isActive: false },
					{ title: 'Ολοκλήρωση', step: 2, isActive: false },
				];

			case 'CreatePasswordComponent':
				return [
					{ title: 'Νέος κωδικός', step: 0, isActive: false },
					{ title: 'Επιβεβαίωση', step: 1, isActive: false },
					{ title: 'Ολοκλήρωση', step: 2, isActive: false },
				];
			case 'ChangePasswordComponent':
				return [
					{ title: 'Αλλαγή Password', step: 0, isActive: false },
					{ title: 'Επιβεβαίωση', step: 1, isActive: false },
					{ title: 'Ολοκλήρωση', step: 2, isActive: false },
				];
			case 'ConnectProfileModal':
				return [
					{ title: 'Επιβεβαίωση χρήστη', step: 0, isActive: false },
					{ title: 'Επιβεβαίωση σύνδεσης', step: 1, isActive: false },
					{ title: 'Ολοκλήρωση', step: 2, isActive: false },
				];
			case 'BlockUser':
				return [
					{ title: 'Εισαγωγή στοιχείων', step: 0, isActive: false },
					{ title: 'Επιβεβαίωση', step: 1, isActive: false },
					{ title: 'Ολοκλήρωση', step: 2, isActive: false },
				];
			default:
				break;
		}
	}
}
